import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import isArray from 'lodash/isArray'
import { FormCheck, Button, Collapse, Row } from 'react-bootstrap'
import {
  IoIosArrowDown as DownwardArrowIcon,
  IoIosArrowUp as UpwardArrowIcon,
} from 'react-icons/io'
import { pageNames } from 'src/routes/pathParams'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import { convertToBoolean, APPConfig } from 'config/appConfig'
import {
  i18nTranslate,
  IS_BROWSER,
  currencyFormat,
  getMonthStringList,
  trackGTMEvents,
  getLocalStorage,
  getSubscriptionActiveTabName,
  isINMarket,
  enableTimeZoneDateConversion,
} from 'src/utils'
import {
  LinkWithLocale,
  ImageComponent,
  Quantity,
  FrequencyDropdownV2,
  DatePickerV2,
  toastState,
  overlayState,
} from 'src/views/components'
import {
  FormInputLabels,
  enableSubscriptionMultiVariant,
  productDeps,
} from 'src/deps'
import { ProductDetails } from 'src/views/components/FlexibleSubscription'
import {
  subscriptionContainer,
  promotionContainer,
  nuskinSubscriptionContainer,
  customerContainer,
  multipleSubscriptionContainer,
  storeContainer,
} from 'src/models'
import linkFromContentStack from 'src/deps/LinkFromContantStack'
import { SubscriptionMultiVariants } from '../SubscriptionMultiVariants'
import './styles.scss'
import { ShippingMethodDropdown } from '../../FrequencyDropdownV2'
import {
  getNotPurchasableSkuStatus,
  getNotPurchasableStatusTestId,
} from 'src/utils/commonUtils'
import { formatDate } from 'src/utils'
import { SHIPPING_TYPE } from 'src/utils/constant'
import { IoIosInformationCircle as InformationIcon } from 'react-icons/io'
import { AuthorizedSubscriptionLimitInfo } from 'src/views/components/MultipleSubscriptionCart/AuthorizedSubscriptionLimit/AuthorizedSubscriptionLimitInfo'
import { AuthorizationLimitInfoModal } from 'src/views/components/MultipleSubscriptionCart/AuthorizedSubscriptionLimit/AuthorizationLimitInfoModal'

@observer
class SingleDrawerProduct extends React.Component {
  enableDangerousGoodsMessage =
    convertToBoolean(APPConfig?.getAppConfig()?.enableDangerousGoodsMessage) ||
    false
  @observable quantity = 1
  @observable productDetails = {}
  @observable selectedSubscriptionDate = new Date()
  @observable selectSubscriptionDate = new Date()
  @observable isAlreadySubscribed = false
  @observable isOneTime = false
  @observable isOpen = false
  @observable isDangerousGood = false
  @observable frequencyData = {
    frequencyPeriod: 1,
    frequencyType: 'Every month',
    type: 'VARIABLE_MULTI_ORDER',
  }
  @observable subscribeButtonEnable = false
  @observable shippingData = {}
  @observable showAuthorizationModal = false

  isDateChanged = false
  isSwitchedFromOnetime = false
  VARIANT_NODES = ['variantLabel']
  isBundle = false
  variantData = {}

  constructor(props) {
    super(props)
    const {
      product = {},
      shippingMethodList = {},
      nonProcessedFutureSubscriptionDates = [],
      availableMinDate = '',
      isFromMultipleSubscriptions = false,
    } = this.props
    // dangerous goods check
    const hasDangerousGoods = skus =>
      skus?.some(sku => convertToBoolean(sku?.skuProperties?.dangerousGoods))

    const type = product?.type?.toLowerCase()
    if (type === 'kit') {
      this.isDangerousGood =
        product?.skuKit?.some(kit => hasDangerousGoods(kit.sku)) ||
        convertToBoolean(product?.dangerousGoods) ||
        false
    } else if (type === 'bundle') {
      this.isDangerousGood =
        product?.bundleMandatoryProducts?.some(bundle =>
          hasDangerousGoods(bundle.sku)
        ) ||
        convertToBoolean(product?.dangerousGoods) ||
        false
    } else {
      this.isDangerousGood = hasDangerousGoods(product?.sku)
    }
    if (product?.isOneTimeProduct) {
      this.isOneTime = true
      this.frequencyData.frequencyPeriod = '1'
      this.frequencyData.type = 'VARIABLE_SINGLE_ORDER'
      this.frequencyData.frequencyType = 'Every month'
    }
    let isSelectMonth = ''
    let isSelectDate = ''
    if (subscriptionContainer.subscriptionSelectedDate) {
      isSelectMonth =
        subscriptionContainer.subscriptionSelectedDate?.split(' ')?.[0] || ''
      isSelectDate =
        subscriptionContainer.subscriptionSelectedDate?.split(' ')?.[1] || ''
      isSelectDate = parseInt(isSelectDate)
    }
    let defaultAddDate = ''
    const startDate = new Date()
    if (isFromMultipleSubscriptions) {
      const { subscriptionDate } = this.props?.data
      this.selectedSubscriptionDate = subscriptionDate
        ? subscriptionDate
        : new Date()
    } else {
      if (isSelectMonth && isSelectDate) {
        nonProcessedFutureSubscriptionDates?.some(date => {
          if (
            date?.getDate() === isSelectDate &&
            getMonthStringList()[date?.getMonth()] === isSelectMonth
          ) {
            defaultAddDate = date
            return true
          }
        })
      }
      this.selectedSubscriptionDate = new Date(
        defaultAddDate ||
          (this.isOneTime && nonProcessedFutureSubscriptionDates?.length
            ? nonProcessedFutureSubscriptionDates?.[0]
            : availableMinDate)
      )
    }

    this.state = {
      first: false,
      second: false,
      searchTerm: this.props?.term || '',
    }
  }

  getAccountType = () => {
    if (IS_BROWSER) {
      return customerContainer.profileResponse?.accounts?.type || ''
    }
    return ''
  }
  isBAorPreferred = () => {
    const accountType = this.getAccountType() || ''
    return (
      accountType === 'Brand Affiliate' ||
      accountType === 'Brand Affiliate - Business Entity' ||
      accountType === 'Preferred Customer/Member' ||
      false
    )
  }
  componentDidMount() {
    const productType = this.props.product?.type || ''
    const product = this.props?.product || {}
    this.isBundle =
      productType?.toLowerCase() === 'kit' ||
      productType?.toLowerCase() === 'bundle'
    try {
      this.productDetails = JSON.parse(JSON.stringify(product)) // taking deep copy of that product json, so that existing wont affect
    } catch (e) {
      console.log('error in JSON file', e)
    }
    this.productDetails.productId =
      this.productDetails?.productId || this.productDetails?.identifier || ''
    this.productDetails.isSubscriptionIncludedInPromotion = !this.isOneTime
    this.productDetails.isSubscriptionPromotion = !this.isOneTime
    this.productDetails.quantity = this.quantity
    if (this.isBundle) {
      this.getBundlePromoAPI(this.productDetails)
      const isMultiVariant = enableSubscriptionMultiVariant()
      if (isMultiVariant) {
        this.isAlreadySubscribed =
          nuskinSubscriptionContainer.isAlreadyASubscribedProduct(product)
      }
    } else {
      promotionContainer.makeSubscriptionPromoAPI(this.productDetails)
    }
    const { isFromMultipleSubscriptions = false, data = {} } = this.props
    const activeTabName = getSubscriptionActiveTabName({
      isFromMultipleSubscriptions,
      activeTab: data?.activeTab,
    })
    trackGTMEvents({
      event: 'subscriptionSearchSelected',
      term: this.props?.term || '',
      name: this.productDetails?.name || '',
      id: this.productDetails?.skuId || '',
      price: this.productDetails?.prices?.[0]?.price || 0,
      type: activeTabName,
    })
  }
  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(
        prevProps?.shippingMethodList?.shippingDetails?.cartShippingMethods
      ) !==
      JSON.stringify(
        this.props?.shippingMethodList?.shippingDetails?.cartShippingMethods
      )
    ) {
      this.shippingData = {}
      this.subscribeButtonEnable = false
    }
  }
  componentWillUnmount() {
    productDeps.optionalData = []
  }
  getBundlePromoAPI = (productDetails = {}) => {
    const { product = {} } = this.props
    const bundleData =
      (productDetails?.bundleProducts?.mandatoryCount &&
        productDetails?.bundleProducts?.mandatoryCount > 0) ||
      (productDetails?.bundleProducts?.optionalCount &&
        productDetails?.bundleProducts?.optionalCount > 0)
        ? productDetails?.bundleProducts
        : productDeps?.getBundleData(product)

    this.productDetails = {
      productId: product?.productId || '',
      quantity: this.quantity?.toString(),
      categoryId: product?.categoryId || '',
      type: product?.type || '',
      isSubscriptionIncludedInPromotion: !this.isOneTime,
      isSubscriptionPromotion: product?.isSubscriptionPromotion || false,
      ...productDetails,
      ...bundleData,
    }
    promotionContainer.makeSubscriptionPromoAPI(this.productDetails)
  }

  getSelectedBundleSkuList = (products = [], filterFn = () => true) =>
    products.filter(filterFn).map(item => ({
      skuId: item?.selectedSku?.identifier,
      productId: item?.identifier,
      skuQuantity: item?.properties?.quantity,
      type: 'bundle',
    }))

  handleQuantityChange = (count = 1) => {
    this.quantity = count
    this.productDetails.quantity = count

    const isMultiVariant =
      enableSubscriptionMultiVariant() &&
      Object.keys(this.variantData)?.length > 0

    if (this.isBundle && isMultiVariant) {
      // Get latest selected mandatory and optional SKUs
      const mandatorySkus = this.getSelectedBundleSkuList(
        this.variantData?.bundleMandatoryProducts,
        () => true
      )
      const optionalSkus = this.getSelectedBundleSkuList(
        this.variantData?.bundleOptionalProducts,
        item => item?.optionalProductAdded
      )
      this.productDetails.skus = [...mandatorySkus, ...optionalSkus]
    } else if (
      isMultiVariant &&
      Array.isArray(this.variantData?.normalSkuVariants) &&
      this.variantData?.normalSkuVariants?.length > 0
    ) {
      // For normal product with multi-variant, set selected skuId
      const selectedVariant = this.variantData?.normalSkuVariants?.find(
        item => item?.isSelected
      )
      if (selectedVariant) {
        this.productDetails.skuId = selectedVariant.identifier
        // keep productDetails.name in sync with the selected variant so
        // messages built off it (e.g. success toast) reflect the chosen type
        this.productDetails.name =
          selectedVariant?.properties?.name || this.productDetails.name
      }
    }
  }

  navigateToTermsAndConditions = async e => {
    e.preventDefault()
    if (IS_BROWSER) {
      // const links = new FormInputLabels()
      // window.open(links.retailCustomerLinks?.subscriptionAgreement)
      if (linkFromContentStack?.termAndConditionLink) {
        window.open(linkFromContentStack?.termAndConditionLink)
      } else {
        const termAndConditionLink =
          await linkFromContentStack.fetchTermsConditionsLink()
        window.open(termAndConditionLink)
      }
    }
  }
  handleKeyPress = e => {
    if (e.keyCode === 13) {
      navigateToTermsAndConditions(e)
    }
  }
  handleChangeCalendar = (timeStamp = '') => {
    this.isDateChanged = true
    this.selectedSubscriptionDate = new Date(timeStamp)
    this.selectSubscriptionDate = new Date(timeStamp)
  }
  handleShippingMethodChange = selected => {
    this.shippingData = {
      deliveryPeriod: selected?.expectedDaysForDelivery,
      shippingInstruction: selected?.description,
      shippingType: selected?.properties?.BOPIS
        ? SHIPPING_TYPE.STORE_PICKUP
        : SHIPPING_TYPE.PHYSICAL,
      shippingMethod: selected?.name,
      shippingId: selected?.shippingMethodId,
    }
    if (selected.shippingMethodId) {
      this.subscribeButtonEnable = true
    }
    this.onCheckboxChange({}, '')
  }
  onCheckboxChange = (e = {}, checkFrom = '') => {
    this.setState({
      first: checkFrom === 'first' ? e?.target?.checked : this.state.first,
      second: checkFrom === 'second' ? e?.target?.checked : this.state.second,
    })
    const { isFromMultipleSubscriptions = false, data = {} } = this.props
    const activeTab = getSubscriptionActiveTabName({
      isFromMultipleSubscriptions,
      activeTab: data?.activeTab,
    })
    const generateTrackGTMEventsParams = (eventName = '') => {
      trackGTMEvents({
        event: eventName,
        term: this.state?.searchTerm || '',
        name: this.productDetails?.name || '',
        id: this.props?.product?.skuId || '',
        price: this.productDetails?.prices?.[0]?.price || 0,
        type: activeTab,
      })
    }

    if (checkFrom === 'first' && e?.target?.checked) {
      generateTrackGTMEventsParams('subscriptionCreditCardAgree')
    }
    if (checkFrom === 'second' && e?.target?.checked) {
      generateTrackGTMEventsParams('subscriptionAgree')
    }
  }
  getSkuDetails = () => {
    let skuDetails = {}
    const { sku = [], productId = '', skuId = '' } = this.productDetails
    skuDetails = [
      {
        skuId: enableSubscriptionMultiVariant()
          ? skuId || '' //selected varaint skuId
          : sku?.[0]?.identifier || '',
        productId,
        type: 'DEFAULT',
      },
    ]
    return skuDetails
  }

  /**
   * Checks if authorization limit is breached for IN market
   */
  isAuthorizationLimitBreached = (
    subscriptionGrandTotal = 0,
    subscriptionData = {}
  ) => {
    const authorizedLimit = Number(
      subscriptionData?.properties?.maxGrandTotal || 0
    )
    const productTotal =
      Number(this.productDetails?.prices?.[0]?.price || 0) *
      Number(this.quantity || 1)

    const isLimitBreached =
      authorizedLimit > 0 &&
      subscriptionGrandTotal + productTotal > authorizedLimit

    return isINMarket() && isLimitBreached
  }

  /**
   * Builds eMandate payload for quick add to subscription
   */
  buildEMandatePayloadForQuickAdd = () => {
    const landingUrl = IS_BROWSER ? window.location.href : ''
    const postDataForQuickAdd = this.getPostDataForAddProductAPI()

    // Transform the data to match eMandate API structure and add itemId
    const items = postDataForQuickAdd.map(item => {
      const {
        quantity = 1,
        productId = '',
        skus = [],
        isSubscription = true,
        subscription = {},
        properties = {},
      } = item || {}

      const itemId =
        this.props?.product?.id ||
        this.props?.product?.itemId ||
        this.productDetails?.id ||
        this.productDetails?.itemId ||
        0

      return {
        quantity,
        itemId,
        skus,
        isSubscription,
        subscription,
        properties,
      }
    })

    return {
      items,
      landingUrl,
    }
  }

  handleSubscribe = async () => {
    // if dangerousGoods items
    if (this.enableDangerousGoodsMessage && this.isDangerousGood) {
      const shippingData = this.shippingData
      const shippingMethodResponse =
        await subscriptionContainer.updateSubscriptionsPreference(
          customerContainer.userId,
          shippingData
        )
    }
    const orderProcessedDate = this.selectedSubscriptionDate?.getDate() || 1
    const month = this.selectedSubscriptionDate?.getMonth() || 0
    const monthText = getMonthStringList()[month]
    const tabName = `${monthText} ${orderProcessedDate}`
    const { quantity = 1 } = this.productDetails
    const skuDetails = this.isBundle
      ? this.productDetails?.skus
      : this.getSkuDetails()
    const currentMonth = new Date().getMonth()
    let postParameters = {}
    let modalData = {
      ...this.props,
      quantity,
      frequency: this.frequencyData.frequencyPeriod,
      frequencyOrder: this.frequencyData.type,
      isOneTimeFrequency: this.isOneTime,
    }

    const isMultiVariant =
      enableSubscriptionMultiVariant() &&
      Object.keys(this.variantData).length > 0
    if (this.isBundle) {
      if (isMultiVariant) {
        modalData.product = {
          ...modalData.product,
          bundleMandatoryProducts: this.variantData?.bundleMandatoryProducts,
          bundleOptionalProducts: this.variantData?.bundleOptionalProducts,
        }
      }

      postParameters =
        nuskinSubscriptionContainer.getPostBodyForAddSubscription(modalData)
      if (postParameters && postParameters?.[0]) {
        postParameters[0].isSubscriptionPreference = true
        postParameters[0].orderProcessedDate = orderProcessedDate
        postParameters[0].month = month >= 0 ? month + 1 : 1
      }
    } else {
      if (
        isMultiVariant &&
        Array.isArray(this.variantData?.normalSkuVariants) &&
        this.variantData?.normalSkuVariants?.length > 0
      ) {
        const variantData = this.variantData?.normalSkuVariants || []
        variantData?.filter(item => {
          if (item.isSelected) {
            this.productDetails.skuId = item.identifier
            // keep productDetails.name in sync with the selected variant so
            // messages built off it (e.g. success toast) reflect the chosen type
            this.productDetails.name =
              item?.properties?.name || this.productDetails.name
          }
        })
      }

      const { skuId = '', productId = '' } = this.productDetails
      postParameters = [
        {
          skuId: skuId,
          productId: productId,
          quantity: quantity,
          subscription: {
            frequencyPeriod: this.frequencyData.frequencyPeriod,
            frequencyType: 'MONTHS',
            type: this.frequencyData.type,
          },
          frequencyPeriod: this.frequencyData.frequencyPeriod,
          frequencyType: 'MONTHS',
          isOneTimeFrequency: this.isOneTime,
          isSubscriptionPreference: true,
          orderProcessedDate,
          month: month >= 0 ? month + 1 : 1,
          // category: categoryName,
        },
      ]
    }
    let previousDateAvailable = false
    if (currentMonth < month) {
      const { availableOrderDates } = this.props
      const selDate = this.selectSubscriptionDate
      selDate.setMonth(selDate.getMonth() - 1)
      previousDateAvailable = availableOrderDates?.some(
        processedDate =>
          processedDate?.getDate() === selDate?.getDate() &&
          processedDate?.getMonth() === selDate?.getMonth() &&
          processedDate?.getFullYear() === selDate?.getFullYear()
      )
    }
    if (previousDateAvailable) {
      await this.props.addQuickSearchProduct(
        postParameters,
        this.isOneTime,
        previousDateAvailable,
        tabName
      )
    } else {
      subscriptionContainer.subscriptionSelectedDate = tabName
      await this.props.addQuickSearchProduct(
        postParameters,
        this.isOneTime,
        false,
        tabName
      )
    }
    const { isFromMultipleSubscriptions = false, data = {} } = this.props
    const activeTab = getSubscriptionActiveTabName({
      isFromMultipleSubscriptions,
      activeTab: data?.activeTab,
    })

    trackGTMEvents({
      event: 'subscriptionAdd',
      term: this.state?.searchTerm || '',
      name: this.productDetails?.name || '',
      id: this.props?.product?.identifier || '',
      price: this.productDetails?.prices?.[0]?.price || 0,
      type: activeTab,
    })
    this.props.toggleDrawerModal()
  }

  getNormalProductSkuDetails = () => {
    let skuDetail = {}
    const { sku = [], productId = '', skuId = '' } = this.productDetails
    skuDetail = [
      {
        skuId: skuId || sku?.[0]?.identifier || '',
        productId,
        type: 'DEFAULT',
      },
    ]
    return skuDetail
  }

  getBundleProductSkuDetails = (selectedBundleData = {}) => {
    const { quantity = 1, product = {} } = selectedBundleData || {}
    const bundleData = productDeps.getBundleData(product, {
      compareAndSetBackorderBasedOnQuantity: true,
      currentlySelectedQuantity: quantity,
    })
    const selectedSkuList = bundleData?.skus || []
    return selectedSkuList
  }

  getPostDataForAddProductAPI = () => {
    const {
      quantity = 1,
      productId = '',
      sku = {},
      properties = {},
    } = this.productDetails

    const { productCategory = '', categoryId = '' } = properties || {}

    const isToShowMultiVariant = enableSubscriptionMultiVariant()
    const isMultiVariantProduct = Object.keys(this.variantData)?.length > 0

    const postDataForQuickAdd = [
      {
        quantity,
        productId: productId,
        isSubscription: !this.isOneTime,
        isOneTimeFrequency: this.isOneTime,
        subscription: {
          frequencyPeriod: this.frequencyData?.frequencyPeriod,
          frequencyType: 'MONTHS',
          type: this.isOneTime
            ? 'VARIABLE_SINGLE_ORDER'
            : 'VARIABLE_MULTI_ORDER',
        },
        properties: {
          categoryId,
          productCategory,
          isOneTimeOrderItem: this.isOneTime,
          frequencyPeriod: this.frequencyData?.frequencyPeriod,
          frequencyType: 'MONTHS',
        },
      },
    ]

    const productDetails = postDataForQuickAdd?.[0] || []

    if (isToShowMultiVariant && isMultiVariantProduct) {
      if (this.isBundle) {
        const selectedBundleData = {
          ...this.props,
          quantity,
          frequency: this.frequencyData?.frequencyPeriod,
          frequencyOrder: this.frequencyData?.type,
          isOneTimeFrequency: this.isOneTime,
          product: {
            ...this.props.product,
            bundleMandatoryProducts: this.variantData?.bundleMandatoryProducts,
            bundleOptionalProducts: this.variantData?.bundleOptionalProducts,
          },
        }
        const bundleSkuPayload =
          this.getBundleProductSkuDetails(selectedBundleData) || []
        productDetails.skus = bundleSkuPayload
      } else {
        const variantData = this.variantData?.normalSkuVariants || []
        if (Array.isArray(variantData) && variantData?.length > 0) {
          variantData?.filter(item => {
            if (item?.isSelected) {
              this.productDetails.skuId = item?.identifier || ''
              // keep productDetails.name in sync with the selected variant so
              // messages built off it (e.g. success toast) reflect the chosen type
              this.productDetails.name =
                item?.properties?.name || this.productDetails.name
            }
          })
        }
        productDetails.skus = this.getNormalProductSkuDetails()
      }
    } else {
      productDetails.skus = this.isBundle
        ? this.productDetails?.skus
        : this.getNormalProductSkuDetails()
    }

    return postDataForQuickAdd
  }

  handleAddToMultipleSubscription = async () => {
    const { subscriptionData, successCallBack } = this.props?.data

    let postDataForQuickAdd = this.getPostDataForAddProductAPI()

    overlayState.toggleLoader()

    const enableLoyaltyPoints =
      storeContainer?.getLoyaltyPointsConfig() || false
    if (enableLoyaltyPoints) {
      // To fetch subscription summary response
      let subscriptionSummary = {}
      try {
        const summaryResponse =
          await multipleSubscriptionContainer.getAllItemSubscriptions(
            subscriptionData?.subscriptionId
          )
        if (
          summaryResponse &&
          multipleSubscriptionContainer.isSuccessResponse(summaryResponse)
        ) {
          subscriptionSummary = summaryResponse
        } else {
          subscriptionSummary = summaryResponse || {}
        }
      } catch (err) {
        subscriptionSummary = {}
      }

      const frequencyPeriod =
        subscriptionSummary?.properties?.frequencyPeriod || null

      if (frequencyPeriod) {
        // Inject frequencyPeriod into each item payload before quick add
        postDataForQuickAdd = postDataForQuickAdd.map(item => ({
          ...item,
          subscription: {
            ...(item.subscription || {}),
            frequencyPeriod: frequencyPeriod,
          },
          properties: {
            ...(item.properties || {}),
            frequencyPeriod: frequencyPeriod,
          },
        }))
      }
    }

    let response = await multipleSubscriptionContainer.quickAddToSubscription({
      data: postDataForQuickAdd,
      subscriptionId: subscriptionData?.subscriptionId,
      successCallBack: successCallBack,
    })
    trackGTMEvents({
      event: 'subscriptionAdd',
      term: this.state?.searchTerm || '',
      name: this.productDetails?.name || '',
      id: this.props?.product?.identifier || '',
      price: this.productDetails?.prices?.[0]?.price || 0,
    })

    // Don't close the drawer for EOSUBMAN001 - we need to show the authorization modal
    const responseCode = response?.responseCode || response?.code || ''
    if (responseCode !== 'EOSUBMAN001' && responseCode !== 'EOSUBMAN002') {
      this.props.toggleDrawerModal()
    }
    if (response && multipleSubscriptionContainer.isSuccessResponse(response)) {
      if (this.isOneTime) {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.successItemOneTime',
            'Item will only ship once with next shipment. Shipment must include subscribed items in order to process.'
          ),
          true
        )
      } else {
        const productName =
          this.productDetails?.name || this.productDetails?.productName || ''
        if (productName) {
          const itemAddedText = i18nTranslate(
            'cartCreateNewSubscriptionComponent.addToSubscription.subscribedSuccessfullyToaster',
            'You have successfully subscribed to %%product_name%%',
            { isNextGenTranslations: true }
          ).replace('%%product_name%%', productName)
          const subscribedMessage = itemAddedText
          toastState.setToastMessage(subscribedMessage, true)
        } else {
          toastState.setToastMessage(
            i18nTranslate(
              'subscription.successItem',
              'Item(s) successfully added to subscription'
            ),
            true
          )
        }
      }
    } else if (response.code && response.code === 'EOSUBMAN001') {
      // eMandate authorization limit exceeded - show authorization modal
      this.showAuthorizationModal = true
    } else if (response.code && response.code === 'EOSUBMAN002') {
      // eMandate limit exceeded for new subscription
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.eMandateLimitExceeded',
          "We're sorry, your automatic delivery amount exceeds eMandate limits. Your changes will not be saved. You can create a new subscription if you wish to continue."
        )
      )
    } else if (response.code && response.code == 'EOGLOB0001') {
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.paymentIssue',
          'You currently do not have a payment method associated with subscriptions. Please add a payment method'
        )
      )
    } else {
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const editFreezeErrorMessage = i18nTranslate(
        'subscription.editFreezeErrorMessage',
        'This subscription order is currently being processed and at this time no changes will be allowed. Please return after your subscription order has shipped to make any changes to your next order.'
      )
      const alreadySubscribedCode = errorCode === 'validation.item.exists'
      const alreadySubscribedMessage = i18nTranslate(
        'cartCreateNewSubscriptionComponent.addToSubscription.itemAlreadySubscribed',
        'Item is already subscribed. Kindly visit subscription dashboard and update the quantity',
        { isNextGenTranslations: true }
      )

      const somethingWentWrongMessage = i18nTranslate(
        'subscription.somethingwentwrong',
        'Sorry, something went wrong. Please try again.'
      )
      const errorMessage = editFreezeErrorCode
        ? editFreezeErrorMessage
        : alreadySubscribedCode
          ? alreadySubscribedMessage
          : somethingWentWrongMessage
      toastState.setToastMessage(errorMessage)
    }
    overlayState.toggleLoader()
  }

  handleSubscriptionFrequency = (value = '', isOneTime = false) => {
    const { isFromMultipleSubscriptions = false } = this.props
    let switchDate = new Date()
    let isSwitch = false
    let available = false
    let isToMakePromoAPI = false
    const [frequencyPeriod, frequencyType] = value?.split?.('-')
    let type = isOneTime ? 'VARIABLE_SINGLE_ORDER' : 'VARIABLE_MULTI_ORDER'
    if (this.frequencyData.type !== type) {
      isToMakePromoAPI = true
    }
    this.frequencyData = {
      frequencyPeriod,
      frequencyType,
      type: isOneTime ? 'VARIABLE_SINGLE_ORDER' : 'VARIABLE_MULTI_ORDER',
    }
    this.isOneTime = isOneTime
    const { nonProcessedFutureSubscriptionDates = [], availableMinDate = '' } =
      this.props
    this.productDetails.isSubscriptionIncludedInPromotion = !isOneTime
    if (nonProcessedFutureSubscriptionDates?.length > 0) {
      available = nonProcessedFutureSubscriptionDates?.some(
        processedDate =>
          processedDate?.getDate() ===
            this.selectedSubscriptionDate?.getDate() &&
          processedDate?.getMonth() ===
            this.selectedSubscriptionDate?.getMonth() &&
          processedDate?.getFullYear() ===
            this.selectedSubscriptionDate?.getFullYear()
      )
    }
    if (this.isSwitchedFromOnetime) {
      isSwitch = true
      switchDate = availableMinDate
    }
    isToMakePromoAPI &&
      promotionContainer.makeSubscriptionPromoAPI(this.productDetails)
    if (!isFromMultipleSubscriptions) {
      if (!available && isOneTime) {
        this.isSwitchedFromOnetime = true
        let date = nonProcessedFutureSubscriptionDates?.[0] || availableMinDate
        if (
          nonProcessedFutureSubscriptionDates?.[0]?.getDate() === 1 &&
          nonProcessedFutureSubscriptionDates?.length > 1
        ) {
          date = nonProcessedFutureSubscriptionDates?.[1]
        } else if (
          nonProcessedFutureSubscriptionDates?.[0]?.getDate() === 1 &&
          nonProcessedFutureSubscriptionDates?.length === 1
        ) {
          date = availableMinDate
        }
        this.selectedSubscriptionDate = date
      } else {
        this.isSwitchedFromOnetime = false
      }

      if (isOneTime && nonProcessedFutureSubscriptionDates?.length === 0) {
        this.selectedSubscriptionDate = availableMinDate
      }
      if (isSwitch) {
        this.selectedSubscriptionDate = switchDate
      }
    }
  }

  setOpen = () => {
    this.isOpen = !this.isOpen
  }
  ordinalDate = () => {
    const { isFromMultipleSubscriptions = false } = this.props
    let enableTimeZoneDateFormat = enableTimeZoneDateConversion() || false

    let date =
      isFromMultipleSubscriptions && enableTimeZoneDateFormat
        ? formatDate(this.selectedSubscriptionDate, { day: '2-digit' })
        : this.selectedSubscriptionDate?.getDate()

    return (
      date +
      (date % 10 == 1 && date != 11
        ? 'st'
        : date % 10 == 2 && date != 12
          ? 'nd'
          : date % 10 == 3 && date != 13
            ? 'rd'
            : 'th')
    )
  }

  renderDatePicker = () => {
    const {
      alreadyProcessedOrderDates = [],
      availableOrderDates = [],
      nonProcessedPastSubscriptionDates = [],
      nonProcessedFutureSubscriptionDates = [],
      availableMinDate = '',
      minDate = '',
      maxDate = '',
      isToDisableCurrentMonthDatesInNextMonth = false,
    } = this.props

    return (
      <DatePickerV2
        minDate={minDate}
        maxDate={maxDate}
        highlightDates={nonProcessedFutureSubscriptionDates}
        selectedDateCalendar={this.selectedSubscriptionDate}
        subscriptionProcessedDates={alreadyProcessedOrderDates}
        availableOrderDates={availableOrderDates}
        nonProcessedPastSubscriptionDates={nonProcessedPastSubscriptionDates}
        handleChangeCalendar={this.handleChangeCalendar}
        includeDateOnly={
          this.isOneTime && nonProcessedFutureSubscriptionDates?.length
            ? nonProcessedFutureSubscriptionDates
            : []
        }
        isOneTime={this.isOneTime}
        UTCclock={false}
        disableCurrentMonthUnprocessedDatesInNextMonth={
          isToDisableCurrentMonthDatesInNextMonth
        }
      />
    )
  }

  updateSelectedVariant = (finalData = {}) => {
    this.variantData = finalData
    const isMultiVariant =
      enableSubscriptionMultiVariant() &&
      Object.keys(this.variantData).length > 0
    if (
      !this.isBundle &&
      isMultiVariant &&
      Array.isArray(this.variantData?.normalSkuVariants)
    ) {
      // Keep productDetails in sync with the selected variant as soon as it
      // changes, so the skuId/name used for the API call and the success
      // toast always match the type the user actually picked (not the
      // default variant shown on initial search results).
      const selectedVariant = this.variantData.normalSkuVariants.find(
        item => item?.isSelected
      )
      if (selectedVariant) {
        this.productDetails.skuId = selectedVariant.identifier
        this.productDetails.name =
          selectedVariant?.properties?.name || this.productDetails.name
      }
    }
    let product = { ...this.props.product }
    if (this.isBundle && isMultiVariant) {
      product = {
        ...product,
        bundleMandatoryProducts: this.variantData?.bundleMandatoryProducts,
        bundleOptionalProducts: this.variantData?.bundleOptionalProducts,
      }
      this.isAlreadySubscribed =
        nuskinSubscriptionContainer.isAlreadyASubscribedProduct(product)
    }
  }

  renderMultiVariantData = () => {
    const { product = {} } = this.props
    const productPromoDetails = {
      productId: product?.productId || product?.identifier || '',
      isSubscriptionIncludedInPromotion: !this.isOneTime,
      isSubscriptionPromotion: !this.isOneTime,
      quantity: this.quantity,
    }

    return (
      <div className="subs-multivariant-section">
        <SubscriptionMultiVariants
          productData={product}
          actionType="add"
          isBundle={this.isBundle}
          productPromoDetails={productPromoDetails}
          updateSelectedVariant={this.updateSelectedVariant}
          selectedSkuId={product?.skuId || ''}
        />
      </div>
    )
  }

  getSelectedSkuStatus = () => {
    const { isFromMultipleSubscriptions = false, product = {} } = this.props
    const isMultiVariantFeatureEnabled = enableSubscriptionMultiVariant()

    if (!isMultiVariantFeatureEnabled)
      return {
        flagInventory: false,
        inventoryStatusView: '',
        shouldDisableButton: false,
      }

    const hasVariantData =
      this.variantData && Object.keys(this.variantData)?.length > 0

    const {
      normalSkuVariants = product?.sku || [],
      bundleMandatoryProducts = product?.bundleMandatoryProducts || [],
      bundleOptionalProducts = product?.bundleOptionalProducts || [],
    } = hasVariantData ? this.variantData : {}

    return getNotPurchasableSkuStatus({
      normalSkuVariants,
      bundleMandatoryProducts,
      bundleOptionalProducts,
    })
  }

  getSelectedVariantDetails = () => {
    const { product = {} } = this.props
    const { sku = [] } = product

    const { normalSkuVariants = {}, isBundle = false } = this.variantData || {}

    const selectedSku =
      Array.isArray(normalSkuVariants) &&
      normalSkuVariants?.length > 0 &&
      normalSkuVariants?.find(item => item.isSelected)

    const {
      identifier = '',
      properties = {},
      productUrl = '',
    } = selectedSku || sku?.[0] || {}
    const { primaryimage = '', name = '', imageURL = '' } = properties
    const productSlugId =
      product?.properties?.slug || product?.slug | product?.productId || ''
    const pathUrl =
      product?.productUrl ||
      `${pageNames.product}/${productSlugId}?variant=${identifier}`

    return {
      skuId: identifier,
      pathUrl: pathUrl,
      productImage: primaryimage || imageURL,
      productName: name,
    }
  }

  getUniqueProductOptions = () => {
    const { sku = [] } = this.props?.product || {}
    //find out variantLabel object exists in skuProperties
    const options = this.VARIANT_NODES.map(key => {
      const values = this.transformSkuProperties(sku, key)

      if (values && values.length)
        return {
          type: key,
          values,
        }
    })
    return options.filter(option => option)
  }

  transformSkuProperties = (skuList = [], key = '') => {
    const productOptionList = []
    if (skuList && skuList.length) {
      skuList.forEach(sku => {
        const propValue = sku?.properties?.[key] || ''
        const isSubscribable = sku?.properties?.issubscription || false
        const identifier = sku?.identifier || ''
        const variantForUrl = sku?.properties?.slug || sku?.identifier || ''

        if (propValue) {
          const imageURL = sku?.properties?.imageURL
          const item = {
            identifier: identifier,
            label: propValue,
            isSubscribable,
            variantForUrl,
          }

          if (productOptionList.length) {
            let flag = false
            productOptionList.forEach(list => {
              if (list.label.toLowerCase() === item.label.toLowerCase()) {
                if (item.isSubscribable === 'true') {
                  list.isSubscribable = item.isSubscribable
                }
                flag = true
              }
            })
            flag === false && productOptionList.push(item)
          } else {
            productOptionList.push(item)
          }
        }
      })
      return productOptionList
    }
  }

  renderAlreadySubscribedMsg = () => {
    return (
      <div
        className="already-subscribed-msg d-flex"
        data-testid="qa-subscription-already-subscribed-msg">
        {i18nTranslate(
          'subscription.alreadySubscribedMsg',
          'Already subscribed. Manage this product in the subscription dashboard.'
        )}
        <span className="info-icon">
          <InformationIcon
            size="1.5rem"
            id="info-icon-drawer"
            className="info-icon"
            aria-label="Info Icon"
          />
        </span>
      </div>
    )
  }

  handleQuantityChangePromotion = async (
    product = {},
    count = this.productDetails?.quantity
  ) => {
    if (count === '' || count === 0) {
      return
    }
    await promotionContainer.makeSubscriptionPromoAPI(this.productDetails)
    if (this.isDangerousGood) {
      await this.props.handleShippingMethod?.(
        this.productDetails?.quantity || 1
      )
    }
  }
  renderAuthorizationLimitInfo = displayTotalValue => {
    const { data = {} } = this.props || {}
    const { subscriptionData = {} } = data
    const authorizedLimit = Number(
      subscriptionData?.properties?.maxGrandTotal || 0
    )
    const existingSubscriptionGrandTotal = Number(
      subscriptionData?.cartValue?.grandTotal || 0
    )
    const subscriptionSubTotal = displayTotalValue
    const isLimitBreached =
      authorizedLimit > 0 &&
      existingSubscriptionGrandTotal + subscriptionSubTotal > authorizedLimit

    // If condition not met, hide this section
    if (!isINMarket() || !isLimitBreached) {
      return null
    }
    return <AuthorizedSubscriptionLimitInfo />
  }

  render() {
    const {
      product = {},
      shippingMethodList,
      nonProcessedFutureSubscriptionDates = [],
      isFromMultipleSubscriptions = false,
    } = this.props
    const currencySign =
      subscriptionContainer.subscriptionPreferenceResponse?.currencySign || '$'
    let productImage =
      product?.primaryimage ||
      product?.imageURL ||
      JSON.parse(product?.productImages || '{}')?.[0]?.url ||
      imagePlaceholder
    let productLink = ''
    const productOrSlugId =
      product?.slug || product?.properties?.slug || product?.productId || ''
    productLink =
      product?.productUrl || `${pageNames.product}/${productOrSlugId}`
    const productName = product?.name || product?.productName || ''
    const skuId = product?.isBundle ? product?.productId : product?.skuId || ''
    const unitValue =
      promotionContainer.subscriptionV2PromoResponse?.unitValue ||
      product?.totalValue ||
      {}
    const isToShowMemberPrice = customerContainer?.isToShowMemberPrice(
      unitValue?.priceFacets
    )
    const productPriceFacetKey = isToShowMemberPrice ? 'Member' : 'Wholesale'
    const totalValue =
      promotionContainer.subscriptionV2PromoResponse?.totalValue ||
      product?.totalValue ||
      {}
    const isBAorPreferred = this.isBAorPreferred()
    let originalPrice = ''
    let priceAfterDiscount = ''
    let displayTotalValue = ''
    if (this.isOneTime) {
      if (isBAorPreferred) {
        originalPrice =
          unitValue?.priceFacets?.[`${productPriceFacetKey} Price`]?.[
            `${productPriceFacetKey} Price`
          ] || ''
        priceAfterDiscount =
          unitValue?.priceFacets?.[`${productPriceFacetKey} Price`]?.[
            `${productPriceFacetKey} PriceAfterDiscount`
          ] || ''
        displayTotalValue =
          totalValue?.priceFacets?.[`${productPriceFacetKey} Price`]?.[
            `${productPriceFacetKey} PriceAfterDiscount`
          ] || ''
      } else {
        originalPrice =
          unitValue?.priceFacets?.['Regular Price']?.['Regular Price'] || ''
        priceAfterDiscount =
          unitValue?.priceFacets?.['Regular Price']?.[
            'Regular PriceAfterDiscount'
          ] || ''
        displayTotalValue =
          totalValue?.priceFacets?.['Regular Price']?.[
            'Regular PriceAfterDiscount'
          ] || ''
      }
    } else {
      originalPrice = unitValue?.originalPrice || ''
      priceAfterDiscount = unitValue?.priceAfterDiscount || ''
      displayTotalValue = totalValue?.priceAfterDiscount || ''
    }
    // const { originalPrice = '', priceAfterDiscount = '' } = unitValue
    const priceObj = {
      currencySymbol: currencySign,
      price: parseFloat(originalPrice),
      discountedPrice: parseFloat(priceAfterDiscount),
      totalValue: {
        originalPrice: parseFloat(originalPrice),
        priceAfterDiscount: parseFloat(priceAfterDiscount),
      },
      unitValue,
    }
    const totalPriceObj = {
      currencySymbol: currencySign,
      price: parseFloat(totalValue?.originalPrice || ''),
      discountedPrice: parseFloat(totalValue?.priceAfterDiscount || ''),
    }
    /* Start - Subscription Quick Search changes for Normal Product with MultiVariants - TD-573 */
    const isMultiVariantFeatureEnabled = enableSubscriptionMultiVariant()
    const isNormalPdtWithVariants =
      this.getUniqueProductOptions()?.length > 0 && product?.type !== 'bundle'
    const selectedSkuVariant = isNormalPdtWithVariants
      ? this.getSelectedVariantDetails()
      : {}

    const isBundleOrNormalPdtWithVariants =
      product?.type === 'bundle' || isNormalPdtWithVariants

    productImage =
      isMultiVariantFeatureEnabled && isNormalPdtWithVariants
        ? selectedSkuVariant?.productImage
        : productImage
    productLink =
      isMultiVariantFeatureEnabled && isNormalPdtWithVariants
        ? selectedSkuVariant?.pathUrl
        : productLink
    const details =
      selectedSkuVariant &&
      isMultiVariantFeatureEnabled &&
      isNormalPdtWithVariants
        ? { ...selectedSkuVariant, priceObj }
        : {
            productImage,
            pathUrl: productLink,
            productName,
            skuId,
            priceObj,
            isOneTime: this.isOneTime,
          }
    /* TD-573 Ends */

    const itemTotalText = i18nTranslate(
      'subscriptionModal.flexItemTotalText',
      'Subtotal does not include shipping or taxes.'
    )
    const subscriptionProcessText = i18nTranslate(
      'subscriptionModal.subscriptionProcessText',
      'You may change or cancel your Subscriptions at any time through your Subscription Dashboard (processing times apply).'
    )
    const agreementCheckboxText = i18nTranslate(
      'subscriptionModal.agreementCheckboxText',
      'I agree the credit card saved on my Subscription will be charged each processing date'
    )
    const termsAndConditionCheckboxText = i18nTranslate(
      'subscriptionModal.termsAndConditionCheckboxText',
      'I have read and agree to the'
    )
    const termsAndConditionCheckboxLink = i18nTranslate(
      'subscriptionModal.termsAndConditionLink',
      'Subscription Terms and Conditions'
    )
    const title =
      product?.type === 'bundle' && isMultiVariantFeatureEnabled
        ? i18nTranslate(
            'subscriptionModal.SubscriptionBundleTitle',
            'Subscribe to this bundle?'
          )
        : i18nTranslate(
            'subscriptionModal.SubscriptionItemTitle',
            'Subscribe to this item?'
          )

    const { flagInventory, inventoryStatusView, shouldDisableButton } =
      this.getSelectedSkuStatus()

    const getShouldEnable = () => {
      const isCheckedOrOneTime =
        (this.state.first && this.state.second) || this.isOneTime
      if (this.enableDangerousGoodsMessage && this.isDangerousGood) {
        return (
          isCheckedOrOneTime &&
          this.subscribeButtonEnable &&
          !shouldDisableButton
        )
      } else {
        return isCheckedOrOneTime && !shouldDisableButton
      }
    }
    const shouldEnable = getShouldEnable()
    let enableTimeZoneDateFormat = enableTimeZoneDateConversion() || false
    const month =
      isFromMultipleSubscriptions && enableTimeZoneDateFormat
        ? formatDate(this.selectedSubscriptionDate, { month: '2-digit' }) - 1
        : this.selectedSubscriptionDate?.getMonth() || 0
    const monthText = getMonthStringList()[month]

    const { frequencyPeriod, frequencyType, type } = this.frequencyData
    const updateIcon = this.isOpen ? (
      <UpwardArrowIcon size={'1.5em'} aria-hidden={true} />
    ) : (
      <DownwardArrowIcon size={'1.5em'} aria-hidden={true} />
    )

    const displayMonth = `${monthText}  ${this.ordinalDate()}`
    const isDisableCalender = isFromMultipleSubscriptions
      ? false
      : nonProcessedFutureSubscriptionDates?.length === 0 && this.isOneTime
    const isOneTimeOnlyProduct = product?.isOneTimeProduct || false
    const enableLoyaltyPoints =
      storeContainer?.getLoyaltyPointsConfig() || false

    return (
      <div className="single-drawer-product-container">
        <div className="Subscription-item-title">{title}</div>
        <div
          className={`d-flex single-drawer-product-wrapper flex-column ${this.isAlreadySubscribed ? 'disabled' : ''}`}>
          <div className="d-flex">
            <div className="product-list-product-img">
              <LinkWithLocale
                to={{
                  pathname: productLink || '',
                }}
                className={`prod-image-wrapper w-100`}>
                <ImageComponent
                  width="100px"
                  height="100px"
                  optimizeImage={true}
                  src={productImage}
                  alt={productName}
                  className={`mw-100 mh-100 prod-img`}
                  data-testid="qa-user-sub-product-image"
                />
              </LinkWithLocale>
            </div>
            <ProductDetails productData={details} />
          </div>
        </div>
        {isMultiVariantFeatureEnabled &&
          isBundleOrNormalPdtWithVariants &&
          this.renderMultiVariantData()}
        <div
          className={`single-drawer-product-details-wrapper ${this.isAlreadySubscribed ? 'disabled' : ''}`}>
          <div className="d-flex align-items-center quantity-wrapper">
            <span className="quantity-label">
              {i18nTranslate('Subscription.quantity', 'Qty')}
            </span>
            <Quantity
              onQuantityChange={this.handleQuantityChange}
              defaultValue={this.quantity || 1}
              isV2QuantityStyle={true}
              handleQuantityChangePromotion={this.handleQuantityChangePromotion}
              product={this.productDetails}
            />
            <div className="subscription-price d-flex w-100 subs-product-price">
              <span className="pr-1 total-label">
                {i18nTranslate('summary.totalText', 'Total')}:
              </span>
              <span className="pr-1 total-price">
                {currencyFormat({
                  price: displayTotalValue,
                })}
              </span>
            </div>
          </div>
          {!enableLoyaltyPoints && (
            <div className="subscription-frequency-wrapper">
              <FrequencyDropdownV2
                title={i18nTranslate('cart.frequency', 'Frequency')}
                frequencyPeriod={frequencyPeriod}
                frequencyType={frequencyType}
                orderType={type}
                handleSubscriptionFrequency={this.handleSubscriptionFrequency}
                isToHideMonthlyFrequency={isOneTimeOnlyProduct}
              />
            </div>
          )}
          {this.renderAuthorizationLimitInfo(displayTotalValue)}
          {!isFromMultipleSubscriptions && (
            <div
              className={`${
                isDisableCalender && 'disabled'
              } subscription-Processing-wrapper`}>
              {this.renderDatePicker()}
            </div>
          )}
          {/* shipping methods */}
          {this.enableDangerousGoodsMessage && this.isDangerousGood && (
            <div className="subscription-Processing-wrapper">
              <ShippingMethodDropdown
                title={i18nTranslate(
                  'checkout.shippingMethod',
                  'Shipping Method'
                )}
                shippingMethodList={shippingMethodList}
                shippingData={this.shippingData}
                handleShippingMethodChange={this.handleShippingMethodChange}
              />
            </div>
          )}
          {this.enableDangerousGoodsMessage && this.isDangerousGood && (
            <div className="d-flex flex-column subscription-terms-wrapper">
              <div className="subscription-Processing-text">
                <span>
                  {i18nTranslate(
                    'dangerous_goods_shipping_method_message',
                    'Selected Shipping Method not available for this item, please change Shipping Method.'
                  )}
                </span>
              </div>
            </div>
          )}
          {this.isOneTime && !isFromMultipleSubscriptions && (
            <div className="d-flex flex-column subscription-terms-wrapper">
              <div className="subscription-Processing-text">
                <span role="button" tabIndex={0} onClick={() => this.setOpen()}>
                  {updateIcon}
                </span>
                <span>
                  {i18nTranslate(
                    'subscription.whythesedays',
                    'Why these days?'
                  )}
                </span>
              </div>

              <Collapse
                in={this.isOpen}
                className="accordion-block-collapse-section subscription-Processing-text  w-100">
                <div id="collapse-text">
                  {i18nTranslate(
                    'subscription.whythesedaydesc',
                    'One-time items will only ship with a recurring item. Available process dates are date with recurring items scheduled to ship.'
                  )}
                </div>
              </Collapse>
            </div>
          )}

          <div className="d-flex flex-column subscription-terms-wrapper">
            <>
              {isDisableCalender && !isFromMultipleSubscriptions ? (
                <div className="text-danger no-processing-text">
                  {i18nTranslate(
                    'subscription.noDate',
                    'No available Date for one time order'
                  )}
                </div>
              ) : (
                <div className="subscription-Processing-text d-flex">
                  <span>
                    {i18nTranslate(
                      'subscription.NextProcessingDate',
                      'Next order date'
                    )}
                    :
                  </span>
                  <span className="pl-1 Processing-date">{displayMonth}</span>
                </div>
              )}
            </>
            <span className="line-one">{itemTotalText}</span>
            {!this.isOneTime && !this.isAlreadySubscribed && (
              <span className="line-two">{subscriptionProcessText}</span>
            )}
          </div>
        </div>

        {!this.isOneTime && !this.isAlreadySubscribed && (
          <div data-testid="qa-subscription-quick-add-agreement">
            <FormCheck className="mt-3 popup-sub subscription-terms-form-wrapper">
              <FormCheck.Input
                checked={this.state.first}
                data-testid="qa-subscription-quick-add-agreement-input"
                onChange={e => this.onCheckboxChange(e, 'first')}
                type="checkbox"
                className="payment-agreement-checkbox"
                id="agreement_checkbox"
              />
              <FormCheck.Label
                className="cursor-default"
                data-testid="qa-subscription-quick-add-agreement-label"
                htmlFor="agreement_checkbox">
                {agreementCheckboxText}
              </FormCheck.Label>
            </FormCheck>
          </div>
        )}
        {!this.isOneTime && !this.isAlreadySubscribed && (
          <div data-testid="qa-subscription-terms-checkbox">
            <FormCheck className="mt-3 popup-sub subscription-terms-form-wrapper">
              <FormCheck.Input
                checked={this.state.second}
                data-testid="qa-subscription-terms-checkbox-input"
                onChange={e => this.onCheckboxChange(e, 'second')}
                type="checkbox"
                className="payment-agreement-checkbox"
                id="terms_checkbox"
              />
              <FormCheck.Label
                className="cursor-default"
                data-testid="qa-subscription-terms-checkbox-label"
                htmlFor="terms_checkbox">
                {termsAndConditionCheckboxText}{' '}
                <div
                  className="ssm-terms-and-conditions-link"
                  role="link"
                  tabIndex="0"
                  onClick={this.navigateToTermsAndConditions}
                  onKeyPress={this.navigateToTermsAndConditions}>
                  <u>{termsAndConditionCheckboxLink}</u>
                </div>
              </FormCheck.Label>
            </FormCheck>
          </div>
        )}

        {flagInventory && (
          <Row
            noGutters
            className="w-100 v2-inventory-message"
            data-testid={getNotPurchasableStatusTestId(inventoryStatusView)}>
            <p
              className={
                'availability-text font-weight-bold p-0 m-0 text-bundle-danger'
              }
              aria-live="polite"
              role="alert">
              {inventoryStatusView}
            </p>
          </Row>
        )}
        {!this.isAlreadySubscribed && (
          <Button
            disabled={!shouldEnable || isDisableCalender || false}
            data-testid="qa-subscription-subscribe-button"
            onClick={() =>
              isFromMultipleSubscriptions
                ? this.handleAddToMultipleSubscription()
                : this.handleSubscribe()
            }
            className={`${isFromMultipleSubscriptions ? 'subscribe-to-group-button' : ''} btn-addToCart single-drawer-modal-btn p-2`}
            variant="primary">
            {i18nTranslate('pdp.subscribe', 'Subscribe', {
              nameSpace: 'ssr-resource',
            })}
          </Button>
        )}

        {this.isAlreadySubscribed && this.renderAlreadySubscribedMsg()}
        {isFromMultipleSubscriptions && (
          <AuthorizationLimitInfoModal
            show={this.showAuthorizationModal}
            currentLimit={Number(
              this.props?.data?.subscriptionData?.properties?.maxGrandTotal ||
                10000
            )}
            subscriptionId={
              this.props?.data?.subscriptionData?.subscriptionId || ''
            }
            isLimitExceeded={true}
            onContinue={() => {
              this.showAuthorizationModal = false
            }}
            onClose={() => {
              this.showAuthorizationModal = false
            }}
          />
        )}
      </div>
    )
  }
}
export default SingleDrawerProduct
export { SingleDrawerProduct }
